
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.875 8.925V3.719a1.095 1.095 0 00-1.094-1.094H7.22a1.095 1.095 0 00-1.094 1.094v5.206l-5.25 3.75v14.45h26.25v-14.45l-5.25-3.75zm2.936 4.247l-2.936 1.92v-4.017l2.936 2.097zM7.875 4.375h12.25v11.86l-3.126 2.045-2.547-1.32-2.777 1.34-3.8-2.308V4.375zm6.549 14.54l10.951 5.68v.78H2.625v-.763l11.799-5.696zM2.625 14.853l7.172 4.354-7.172 3.463v-7.817zm16.157 4.353l6.593-4.311v7.73l-6.593-3.42zm-12.657-8.13v3.855l-2.917-1.771 2.917-2.084z"}})])
          )
        }
      }
    